import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { DesktopAndTabletLeftBlock } from './DesktopAndTabletLeftBlock';
import { ProductsDesktopAndTabletCustomSlider as DesktopAndTabletSlider } from './ProductsDesktopAndTabletCustomSlider';
import type { ProductGridProps } from './type';

const DesktopProductGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 35% 65%;
  padding: 0 ${theme.spacing['8x']};
`;

export const DesktopProductsGrid = ({ cards, textData }: ProductGridProps) => {
  return (
    <DesktopProductGridWrapper>
      <DesktopAndTabletLeftBlock textData={textData} />
      <div>
        <DesktopAndTabletSlider cards={cards} />
      </div>
    </DesktopProductGridWrapper>
  );
};
